<template>
  <div v-if="alumnos">

    <table class="table table-striped table-bordered table-hover" id="tabla-alumnos">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Apellidos</th>
          <th>Nivel</th>
          <th>Clase</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="p in Object.values(alumnos)" :key="p.id">
          <td class="align-middle" @click="abrirFamilia(p.id_familia)" @click.middle="abrirFamiliaTab(p.id_familia)">{{ p.nombre }}</td>
          <td class="align-middle" @click="abrirFamilia(p.id_familia)" @click.middle="abrirFamiliaTab(p.id_familia)">{{ p.apellidos }}</td>
          <td class="align-middle celda-nivel" :data-sort="p.nivel.id + '/' + p.nivel.clase">
            <select class="select form-control form-inline selector-nivel" :class="alumnos[p.id].nivel.id != cambiosNiveles[p.id].id_nivel ? ['bg-success', 'text-white'] : []" name="nivel" v-model="cambiosNiveles[p.id].id_nivel" @change="cambiarNivelClase(p.id)">
              <option v-for="n of nivelesPosiblesAlumno(p)" :key="n.id_nivel" :value="n.id_nivel">{{ n.nombre }}</option>
            </select>
          </td>
          <td class="align-middle celda-clase">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <label v-for="clase in nivelesAlumnos[p.nivel.id].clases" :key="clase" class="btn" :class="[cambiosNiveles[p.id].clase == clase ? 'active' : '', alumnos[p.id].nivel.clase == cambiosNiveles[p.id].clase ? 'btn-outline-secondary' : 'btn-outline-success']">
              <input type="radio" name="options" class="btn-sm boton-clase" :value="clase" v-model="cambiosNiveles[p.id].clase" @change="cambiarNivelClase(p.id)">
              {{ clase }}
              </label>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import { api } from '../api/api.js';
import { obtenerNiveles } from '../curso.js';

import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';

export default {
	name: 'AdminCambioNiveles',
	data () {
		return {
			dataTable: null,
			alumnos: null,
			cambiosNiveles: null,
			nivelesAlumnos: null,
			nivelExalumnos: null,
		}
	},
	created () {
		this.construirNiveles();
		this.obtenerAlumnos();
	},
	methods: {
		construirNiveles() {
			const niveles = obtenerNiveles();
			this.nivelesAlumnos = {};
			for (const n of niveles) {
				if (n.seccion == 'alumnos') {
					this.nivelesAlumnos[n.id_nivel] = n;
				} else if (n.seccion == 'exalumnos') {
					this.nivelExalumnos = n;
				}
			}
		},
		nivelesPosiblesAlumno(persona) {
			const niveles = [];
			const id_nivel = persona.nivel.id;
			if (id_nivel > 1) {
				niveles.push(this.nivelesAlumnos[id_nivel-1]);
			}
			niveles.push(this.nivelesAlumnos[id_nivel]);
			niveles.push(this.nivelExalumnos);
			return niveles;
		},
		cambiarNivelClase(id_persona) {
			const data = {
				id: this.cambiosNiveles[id_persona].id_nivel,
				clase: this.cambiosNiveles[id_persona].clase,
			}
			api(`/personas/${id_persona}/nivel`, 'PUT', data)
				.then((data) => {
					if (data.resultado) {
						//
					}
				});
		},
		obtenerAlumnos() {
			api('/personas/seccion/alumnos')
				.then((data) => {
					const alumnos = {};
					const cambiosNiveles = {};
					for (const a of data.resultado) {
						alumnos[a.id] = a;
						cambiosNiveles[a.id] = {
							id_nivel: a.nivel.id,
							clase: a.nivel.clase,
						};
					}
					this.cambiosNiveles = cambiosNiveles;
					this.alumnos = alumnos;
					this.$nextTick(() => {
						this.prepararTabla();
					});
				});
		},
		abrirFamilia(id_familia) {
			this.$router.push('/admin/familia/' + id_familia);
		},
		abrirFamiliaTab(id_familia) {
			window.open('/admin/familia/' + id_familia);
		},
		prepararTabla() {
			this.dataTable = $('#tabla-alumnos').DataTable({
				"paging": false,
				"order": [[2, "asc"], [1, "asc"], [0, "asc"]],
				"dom": "<'row'<'col-12'tr>>",
				"language": {
					"lengthMenu": "_MENU_ filas",
					"info": "_TOTAL_ filas",
					"infoEmpty": "0 filas",
					"infoFiltered": "", // _MAX_
					"zeroRecords": "No hay filas que mostrar",
					"emptyTable": "Sin datos en la tabla",
					"paginate": {
						"first": "&lt;&lt;",
						"previous": "&lt;",
						"next": "&gt;",
						"las": "&gt;&gt;",
					}
				},
			});
		},
	}
}
</script>
